import http from 'http.js';
import ko from 'knockout';

import 'knockout.validation';

// Configure validation
ko.validation.init({
    insertMessages: true,
    decorateInputElement: false,
    errorElementClass: 'has-error',
    errorMessageClass: 'help-block',
    messagesOnModified: true,
    decorateElementOnModified: true,
});

ko.validation.rules.medicareProvider = {
    message:
        'Incorrect medicare number, please match the following format eg. 1234561A.',
    validator(val) {
        if (!val) {
            return true;
        }
        const string = /^(\d{5,6})([0-9A-HJ-NP-RT-Y])([YXWTLKJHFBA])$/i;
        return val.match(string);
    },
};

ko.validation.rules.email = {
    message: 'Please enter a valid email address.',
    validator(val) {
        if (!val) {
            return true;
        }
        return val.match(/\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,24}\b/i);
    },
};

ko.validation.rules.checked = {
    validator(val) {
        return val;
    },
    message: 'This checkbox must be ticked',
};

ko.validation.rules.checkEmail = {
    async: true,
    message: 'Email address already in use.',
    async validator(val, params, callback) {
        if (!val) {
            callback(true);
            return;
        }

        // let caller specify that initial value is a safe one
        // e.g. user's current email
        const ignoreInitVal = params.ignoreInitVal || false;

        if (ignoreInitVal) {
            // store init val for later checking
            if (val && !params.initVal) {
                params.initVal = val;
                callback(true);
                return;
            }
            // This isn't init, but is it the same?
            if (val && val === params.initVal) {
                callback(true);
                return;
            }
            // Else continue processing as normal
        }

        // If the email is invalid then don't check if it exists
        if (!ko.validation.rules.email.validator(val)) {
            callback(true);
            return;
        }

        const data = {
            email: val,
        };
        const exists = await http.get({
            url: '/api/base/v1/email-exists/',
            data,
        });
        // Valid if doesn't exist
        callback(!exists);
    },
};

ko.validation.rules.checkUsername = {
    async: true,
    message: 'Username already taken.',
    async validator(val, params, callback) {
        if (!val) {
            callback(true);
            return;
        }

        // let caller specify that initial value is a safe one
        // e.g. user's current username
        const ignoreInitVal = params.ignoreInitVal || false;

        if (ignoreInitVal) {
            // store init val for later checking
            if (val && !params.initVal) {
                params.initVal = val;
                callback(true);
                return;
            }
            // This isn't init, but is it the same?
            if (val && val === params.initVal) {
                callback(true);
                return;
            }
            // Else continue processing as normal
        }

        const data = {
            username: val,
        };
        const exists = await http.get({
            url: '/api/base/v1/username-exists/',
            data,
        });
        // Valid if doesn't exist
        callback(!exists);
    },
};

ko.validation.rules.practicePhone = {
    message:
        'Please enter a valid 10 digit or 6 digit Australian phone number.',
    validator(val) {
        if (!val) {
            return true;
        }
        // Remove valid special chars and spaces
        const num = val.replace(/[+\-().\s]/g, '');
        // What we have left should be a number of ten digits
        return num.match(/^\d{10}$/) || num.match(/^\d{6}$/);
    },
};

ko.validation.rules.phone = {
    message: 'Please enter a valid 10 digit Australian phone number.',
    validator(val) {
        if (!val) {
            return true;
        }
        // Remove valid special chars and spaces
        const num = val.replace(/[+\-().\s]/g, '');
        // What we have left should be a number of ten digits
        return num.match(/^\d{10}$/);
    },
};

// Django regex validator to ensure what we okay here will work on server
const urlRegexParts = [
    '^https?://', // protocol
    '(?:(?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\\.)',
    '+(?:[A-Z]{2,24}\\.?|[A-Z0-9-]{2,}(?:<!-)\\.?)|', // domain
    'localhost|', // localhost
    '\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}|', // or ipv4
    '\\[?[A-F0-9]*:[A-F0-9:]+\\]?)', // or ipv6
    '(?::\\d+)?', // port?
    '(?:/?|[/?]\\S+)$', // path
];
const urlRegex = new RegExp(urlRegexParts.join(''), 'i');

ko.validation.rules.url = {
    message: 'Please enter a valid url.',
    validator(val) {
        if (!val) {
            return true;
        }
        return val.match(urlRegex);
    },
};

ko.validation.registerExtenders();
